import { addCacheBuster } from "../../utils/imageUtils";
import { getPrixiLogoSrc } from "./invitePrixiLogo";
import type { InviteIntegrationSource, InviteViewPhase } from "./inviteTypes";
import {
  isInviteInactivePhase,
  isInviteTerminalHeroPhase,
} from "./invitePhaseUtils";

const ensureDirectS3Url = (url: string): string => {
  if (url.includes("podscope.s3.amazonaws.com/")) return url;
  if (url.includes("/api/proxy/s3/")) {
    const key = url.split("/api/proxy/s3/")[1];
    return `https://podscope.s3.amazonaws.com/${key}`;
  }
  return url;
};

export function resolveCompanyImageSrc(opts: {
  companyImageS3Key?: string;
  companyImageUrl?: string;
}): string | null {
  const { companyImageS3Key, companyImageUrl } = opts;
  if (companyImageS3Key) {
    return addCacheBuster(
      ensureDirectS3Url(
        `https://podscope.s3.amazonaws.com/${companyImageS3Key}`,
      ),
    );
  }
  if (companyImageUrl) {
    return addCacheBuster(ensureDirectS3Url(companyImageUrl));
  }
  return null;
}

export function resolveInviteHeroImageSrc(opts: {
  integrationSource?: InviteIntegrationSource;
  heroVariant: InviteHeroVariant;
  companyImageS3Key?: string;
  companyImageUrl?: string;
}): string | null {
  const { integrationSource, heroVariant, companyImageS3Key, companyImageUrl } =
    opts;

  if (integrationSource === "prixi") {
    return heroVariant === "company" ? getPrixiLogoSrc() : null;
  }

  return resolveCompanyImageSrc({ companyImageS3Key, companyImageUrl });
}

export type InviteHeroVariant = "company" | "success" | "inactive" | "error";

export function getInviteHeroImageAlt(opts: {
  integrationSource?: InviteIntegrationSource;
  heroVariant: InviteHeroVariant;
  companyName?: string;
}): string {
  if (opts.integrationSource === "prixi" && opts.heroVariant === "company") {
    return "Prixi";
  }
  return opts.companyName ? `Logo de ${opts.companyName}` : "Empresa";
}

export function getInviteHeroVariant(viewPhase: InviteViewPhase): InviteHeroVariant {
  if (viewPhase === "fatal") return "error";
  if (isInviteInactivePhase(viewPhase)) return "inactive";
  if (isInviteTerminalHeroPhase(viewPhase)) return "success";
  return "company";
}
